<template>
    <a :href="href" @click="onClick">
        <slot />
    </a>
</template>

<script lang="ts">
    import { defineComponent, PropType } from 'vue';

    import {
        currentRpId, kbLocation, KbNavigationTarget, routeForTarget,
    } from '@/modules/kb/components/KbArticleContent/helpers';

    // The href stays tenant-free so a copied link opens in whichever client the opener is on. A
    // plain click navigates with the tenant in the current URL instead: tenant-free navigation
    // would take the client from `$lastSelectedRp`, which another tab may have changed.
    export default defineComponent({
        name: 'KbLink',
        props: {
            target: {
                type: Object as PropType<KbNavigationTarget>,
                required: true,
            },
        },
        computed: {
            href(): string {
                return this.$router.resolve(kbLocation(this.target)).href;
            },
        },
        methods: {
            onClick(event: MouseEvent): void {
                if (event.button !== 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) {
                    return;
                }
                event.preventDefault();
                this.$router.push(routeForTarget(this.target, currentRpId(this.$route)));
            },
        },
    });
</script>
